<template>
  <HomeLayout>
    <b-row class="column-border-container" :class="{ 'vtd-height-80-percent': showOnlyOneNumberMessage }">
      <b-col class="column-border col-lg card-col col-12">
        <div class="vtd-card vtd-animate-shake" @click="openThisBookingModal">
          <div class="navigation-block" :class="{ 'vtd-realign-icon': showOnlyOneNumberMessage }">
            <h4 class="nav-title-center">
              THIS BOOKING IS FOR
            </h4>
            <div class="nav-text-center">
              <i class="icon-account vtd-icon-7"/>
            </div>
          </div>
          <ThisBookingIsFor ref="ThisBookingIsForModal" />
          <div class="vtd-card-footer nav-text-center d-none d-lg-block">
            <p class="vtd-home-btn text-center">
              View Now
            </p>
          </div>
        </div>
      </b-col>

      <b-col class="column-border col-lg card-col col-12">
        <div class="vtd-card vtd-animate-shake" @click.prevent="() => {
            $refs.LoginTokenRef.authCheckResult(() => {
              showCheckUpdateDetails = true;
            });
          }
          ">
          <div class="navigation-block" :class="{ 'vtd-pb-0': showOnlyOneNumberMessage }">
            <h4 class="nav-title-center">
              CHECK &amp; UPDATE YOUR CONTACT DETAILS
            </h4>
            <div class="nav-text-center" :class="{ 'vtd-padding-zero': showOnlyOneNumberMessage }">
              <i class="icon-account vtd-icon-7"/>
            </div>
          </div>


          <b-alert show variant="danger" class="alert alert-card-combo alert-primary mx-2"
            v-if="showOnlyOneNumberMessage">
            <div class="row">
              <div class="col-md-3"><i class="material-icons vtd-icon-4">phone_android</i></div>
              <div class="col-md-9">
                <p>Our records show that we only hold one contact number. Please add additional contact numbers to allow
                  us to successfully contact you with operational updates where necessary.</p>
              </div>

            </div>
        </b-alert>
        <div v-if="showCheckUpdateDetails">
          <CheckUpdateDetails ref="CheckUpdateDetailsModal" :profile="profile" @hide-modal="hideDetailsModal"/>
        </div>
        <div class="vtd-card-footer nav-text-center d-none d-lg-block">
          <p class="vtd-home-btn text-center">
            View Now
          </p>
        </div>
        </div>
      </b-col>

    </b-row>
    <HomeBackBtns />
    <LoginToken ref="LoginTokenRef" />
  </HomeLayout>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import HomeLayout from "@/partials/home-layout";
import ThisBookingIsFor from "@/modules/navigation/modals/this-booking";
import CheckUpdateDetails from "@/modules/navigation/modals/check-and-update-details";
import LoginToken from "@/modules/auth/login-token";

export default {
  components: {
    HomeLayout,
    ThisBookingIsFor,
    CheckUpdateDetails,
    LoginToken,
  },
  data() {
    return {
      showCheckUpdateDetails: false
    };
  },
  computed: {
    ...mapGetters({
      essentialInfoMenu: "essentialInfoMenu/getMenu"
    }),
    ...mapState({ profile: (state) => state.profile.data }),
    ...mapState({ booking: (state) => state.booking }),
    showOnlyOneNumberMessage() {
      return this.booking.booking.user_information.bookingAddress.tel.tel_02.number === 'PLEASE ADVISE';
    }
  },
  watch: {
    showCheckUpdateDetails(newValue) {
      if (newValue) {
        this.$nextTick(() => {
          this.openCheckDetailsModal();
        });
      }
    },
  },
  methods: {
    openThisBookingModal() {
      this.$refs["ThisBookingIsForModal"].showModal();
    },
    openCheckDetailsModal() {
      if (this.$refs["CheckUpdateDetailsModal"]) {
        this.$refs["CheckUpdateDetailsModal"].showModal();
      }
    },
    hideDetailsModal() {
      this.showCheckUpdateDetails = false;
    }
  },
};
</script>
<style scoped>
@media only screen and (min-width: 600px) {
  .vtd-icon-4 {
    font-size: 4em;
    margin-top: 0.5em;
  }

  .vtd-realign-icon {
    justify-content: flex-start
  }

  .vtd-padding-zero {
    padding: 0px;
  }

  .vtd-height-80-percent {
    height: 80%;
  }

  .vtd-pb-0 {
    padding-bottom: 0px;
  }
}
</style>